import { InteractionRequiredAuthError } from '@azure/msal-browser';
import apiClient from 'services/_infra/apiClient';
import { loginfo } from 'services/_infra/util/apiUsageLogger';

export async function tryMsAuthSilent(instance, scopes = []) {
  try {
    // If no instance provided just return null without noisy warnings (common callers pass null)
    if (!instance) return null;

    const accounts = instance.getAllAccounts ? instance.getAllAccounts() : [];
    if (!accounts || accounts.length === 0) {
      if (process.env.NODE_ENV === 'development') {
        console.warn('No MS account found - Microsoft authentication not configured');
      }
      return null;
    }

    const accessTokenRequest = {
      scopes: scopes,
      account: accounts[0],
    };
    let msRes = null;
    try {
      msRes = await instance.acquireTokenSilent(accessTokenRequest);
    } catch (err) {
      try {
        if (err instanceof InteractionRequiredAuthError) {
          msRes = await instance.acquireTokenPopup(accessTokenRequest);
        }
      } catch (error) {
        console.error(error);
      }
    }

    if (!msRes) {
      console.error('Could not get MS token');
      return null;
    }
    return msRes;
  } catch (e) {
    console.error('Error getting MS token', e);
    return null;
  }
}

export async function ms_syncAllUsers(instance) {
  loginfo();
  console.debug('[ms_syncAllUsers] starting');
  const msRes = await tryMsAuthSilent(instance, ['Group.Read.All']);
  if (!msRes) {
    console.warn('[ms_syncAllUsers] could not acquire MS token');
    throw new Error('Could not acquire MS token');
  }
  try {
    const res = await apiClient.post(
      '/MsSyncAllUsers',
      {},
      {
        headers: {
          MsAuth: `Bearer ${msRes.accessToken}`,
        },
      },
    );
    console.debug('[ms_syncAllUsers] success', res?.data);
    return res;
  } catch (error) {
    console.error('MsSyncAllUsers failed.', error);
    throw error;
  }
}

export async function ms_getSecurityGroups(instance) {
  loginfo();
  const msRes = await tryMsAuthSilent(instance, ['Group.Read.All']);
  if (!msRes) {
    throw new Error('Could not get MS token');
  }
  try {
    return await apiClient.get('/getMsSecurityGroups', {
      headers: {
        MsAuth: `Bearer ${msRes.accessToken}`,
      },
    });
  } catch (error) {
    console.error('getMsSecurityGroups failed.', error);
  }
}
